import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useData } from '../store/DataContext';
import { User, Lock, Eye, EyeOff } from 'lucide-react';
import { useIndependenceDayTheme } from '../hooks/useIndependenceDayTheme';
import { zambiaFlagColors } from '../utils/independenceDay';
export const Login: React.FC = () => {
  const {
    isIndependenceDay,
    theme
  } = useIndependenceDayTheme();
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const {
    login
  } = useData();
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const result = login(fullName, password);
    if (result.ok) {
      navigate('/dashboard');
    } else {
      setError(result.error || 'Invalid username or password');
    }
  };
  return <div className="min-h-screen flex items-center justify-center px-4" style={theme.pageStyle} data-id="element-7012" data-mp="3r57g1m44ojef">
      <div className="w-full max-w-md" data-id="element-7013" data-mp="2rey7isgtm2c7">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden" data-id="element-7014" data-mp="2mihg9pebr7uw">
          {isIndependenceDay && <div data-id="element-7015" data-mp="3173zi272ojre">
              {/* Zambian flag stripes: red, black, orange */}
              <div className="flex h-5 sm:h-6" aria-hidden="true" data-id="element-7016" data-mp="2wflvf59r6327">
                <span className="flex-1" style={{
              background: zambiaFlagColors.red
            }} data-id="element-7017" data-mp="2wearn5gb4vb3" />
                <span className="flex-1" style={{
              background: zambiaFlagColors.black
            }} data-id="element-7018" data-mp="3a5pejndc5gnf" />
                <span className="flex-1" style={{
              background: zambiaFlagColors.orange
            }} data-id="element-7019" data-mp="3587buepwvxnv" />
              </div>
              <p className="px-4 py-3 text-center text-base font-extrabold tracking-wide sm:text-lg" style={{
            background: zambiaFlagColors.black,
            color: zambiaFlagColors.orange
          }} data-id="element-7020" data-mp="3k3na6vxiyfq2">
                HAPPY INDEPENDENCE DAY ZAMBIA
              </p>
            </div>}
          {/* Header Section */}
          <div className="pt-10 pb-6 px-8 text-center" data-id="element-7021" data-mp="2ahj7fiyvutqs">
            <div className="flex justify-center mb-4" data-id="element-7022" data-mp="2aj40131n02m0">
              <div className={`h-28 w-28 rounded-full border-4 ${theme.logoRing} p-1 flex items-center justify-center bg-white shadow-lg`} data-id="element-7023" data-mp="2ej4egnoqkdt2">
                <img src="https://cdn.magicpatterns.com/uploads/3HmLapdTMRvTJbmSkdh1g8/Bmedhospital.png" alt="BMED Medical Centre" className="h-20 w-20 object-contain rounded-full" data-id="element-7024" data-mp="2jjsgs5if0h2l" />
              </div>
            </div>
            <h1 className={`text-2xl font-bold ${theme.heading} tracking-wide`} data-id="element-7025" data-mp="2xf4ac9ku41hx">
              BMED MEDICAL CENTRE
            </h1>
            <p className="text-sm text-gray-500 mt-1" data-id="element-7026" data-mp="376qs6orogytn">Caring Healing Leading</p>
          </div>

          {/* Form Section */}
          <div className="px-8 pb-8" data-id="element-7027" data-mp="3c765xhfvg8c5">
            <form onSubmit={handleLogin} className="space-y-5" data-id="element-7028" data-mp="3c40g1zzf52fd">
              <div data-id="element-7029" data-mp="3h697ut0k1yfw">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7030" data-mp="3h5g13s1lj8xr">
                  Full Name
                </label>
                <div className="relative" data-id="element-7031" data-mp="10irko95pabut">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-7032" data-mp="10hykjr18ykln">
                    <User className="h-5 w-5 text-gray-400" data-id="element-7033" data-mp="vkga1w7kzxbj" />
                  </div>
                  <input type="text" required value={fullName} onChange={e => setFullName(e.target.value)} placeholder="e.g. Chanda Mwale" className={`block w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl text-sm placeholder-gray-400 focus:outline-none focus:ring-2 ${theme.inputFocus} transition-colors`} data-id="element-7034" data-mp="qln7gytu1qq5" />
                </div>
              </div>

              <div data-id="element-7035" data-mp="26zvgdqlok1jb">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7036" data-mp="270em88y22zgz">
                  Password
                </label>
                <div className="relative" data-id="element-7037" data-mp="226aehngyuneu">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-7038" data-mp="1mp2dd255pv4s">
                    <Lock className="h-5 w-5 text-gray-400" data-id="element-7039" data-mp="1rq8b5edoc8l6" />
                  </div>
                  <input type={showPassword ? 'text' : 'password'} required value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className={`block w-full pl-10 pr-12 py-3 border border-gray-300 rounded-xl text-sm placeholder-gray-400 focus:outline-none focus:ring-2 ${theme.inputFocus} transition-colors`} data-id="element-7040" data-mp="1cspn6e8tlzes" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-7041" data-mp="20pllsadjb37h">
                    {showPassword ? <EyeOff className="h-5 w-5 text-gray-400 hover:text-gray-600" data-id="element-7042" data-mp="2t891195uno0n" /> : <Eye className="h-5 w-5 text-gray-400 hover:text-gray-600" data-id="element-7043" data-mp="houhm75fdf81" />}
                  </button>
                </div>
                <p className="mt-1.5 text-xs text-gray-400" data-id="element-7044" data-mp="rfp1j4v782qb">
                  Min 6 chars, with numbers &amp; signs
                </p>
              </div>

              {error && <div className="text-sm text-red-600 bg-red-50 p-3 rounded-xl border border-red-200 text-center" data-id="element-7045" data-mp="3uwxjdopxf2l1">
                  {error}
                </div>}

              <button type="submit" className="w-full py-3.5 rounded-xl text-white font-semibold text-base shadow-lg hover:shadow-xl transition-all duration-200 hover:opacity-95 active:scale-[0.98]" style={theme.buttonStyle} data-id="element-7046" data-mp="7srfv2ehjilm">
                Sign In
              </button>
            </form>
          </div>
        </div>

        {/* Footer */}
        <p className={`text-center ${theme.footer} text-xs mt-6`} data-id="element-7047" data-mp="bw6ux54mwu8z">
          © 2026 BMED Medical Centre. All rights reserved.
        </p>
      </div>
    </div>;
};